module.exports = __webpack_public_path__ + "static/media/TeamImage.c3834b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/AboutView/TeamImage.png
// module id = 362
// module chunks = 0